import { childrenBusinessPageBreadcrumbs } from '../../config';
import { SearchBar, AuthorizationsTable } from './components';
import { useAuthorizationsFilter } from './hooks';
import { AuthorizationsFilter } from './models';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { useMemo } from 'react';

export const Authorizations = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenBusinessPageBreadcrumbs(navigate),
    [navigate]
  );

  const { filter, setFilter, initialFilter } = useAuthorizationsFilter();

  const handleSearch = (filters: AuthorizationsFilter) => {
    setFilter(filters);
  };

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks actualPage='Autorizaciones' breadcrumbs={breadcrumbs} />
      <SearchBar
        onSearch={handleSearch}
        initialFilter={initialFilter}
        currentFilter={filter}
      />
      <AuthorizationsTable authorizationsFilter={filter} />
    </section>
  );
};

export default Authorizations;
